/* ============================================================
   O66Y LUXURY STREETWEAR - Global Theme JavaScript
   Pure Vanilla JS | Zero Dependencies
   ============================================================ */

'use strict';

/* --- Scroll Reveal --- */
const initScrollReveal = () => {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(el => observer.observe(el));
};

/* --- Cart Overlay --- */
const initCartOverlay = () => {
  const overlay = document.getElementById('CartOverlay');
  if (!overlay) return;

  overlay.addEventListener('click', () => {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  });
};

/* --- Smooth Anchor Scroll --- */
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
};

/* --- Swipeable Product Card Gallery (touch only) ---
   Desktop keeps the CSS :hover slide-to-2nd-image behavior.
   On touch, dragging left/right slides a real image track continuously
   (following the finger) and moves a continuous progress bar; on release it
   snaps to the nearest image. A plain tap still navigates to the product —
   only a real drag past SWIPE_THRESHOLD is intercepted. */
const initSwipeableCards = () => {
  const SWIPE_THRESHOLD = 40;
  let card = null;
  let slides = null;
  let thumb = null;
  let count = 0;
  let index = 0;
  let cardWidth = 1;
  let startX = 0;
  let startY = 0;
  let lastDx = 0;
  let isDragging = false;
  let didSwipe = false;

  function setSlides(pct, animate) {
    slides.style.transition = animate ? '' : 'none';
    slides.style.transform = 'translateX(' + pct + '%)';
  }
  function setThumb(pos, animate) {
    if (!thumb) return;
    thumb.style.transition = animate ? '' : 'none';
    thumb.style.transform = 'translateX(' + (pos * 100) + '%)';
  }
  function commit(i) {
    index = Math.max(0, Math.min(count - 1, i));
    setSlides(-index * 100, true);
    setThumb(index, true);
  }

  document.addEventListener('touchstart', (e) => {
    card = null;
    const found = e.target.closest('.product-card--swipeable');
    if (!found) return;
    slides = found.querySelector('.product-card__slides');
    if (!slides) return;
    count = parseInt(slides.dataset.count, 10) || slides.children.length;
    if (count < 2) { slides = null; return; }

    card = found;
    thumb = found.querySelector('.product-card__swipe-bar__thumb');
    if (thumb) thumb.style.width = (100 / count) + '%';
    cardWidth = found.getBoundingClientRect().width || 1;

    /* Read current index from the track's transform */
    index = 0;
    const m = /translateX\(\s*(-?[\d.]+)%/.exec(slides.style.transform || '');
    if (m) index = Math.round(Math.abs(parseFloat(m[1])) / 100);

    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    lastDx = 0;
    isDragging = false;
    didSwipe = false;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!card) return;
    const dx = e.touches[0].clientX - startX;
    const dy = e.touches[0].clientY - startY;

    if (!isDragging) {
      if (Math.abs(dy) > Math.abs(dx)) { card = null; return; } /* vertical scroll wins */
      if (Math.abs(dx) > 6) isDragging = true;
    }
    if (!isDragging) return;

    lastDx = dx;
    if (Math.abs(dx) > SWIPE_THRESHOLD) didSwipe = true;

    /* Follow the finger, with resistance at the ends */
    let offset = (-index * 100) + (dx / cardWidth * 100);
    const min = -(count - 1) * 100;
    if (offset > 0) offset *= 0.35;
    if (offset < min) offset = min + (offset - min) * 0.35;
    setSlides(offset, false);

    let pos = index - dx / cardWidth;
    pos = Math.max(0, Math.min(count - 1, pos));
    setThumb(pos, false);
  }, { passive: true });

  function endGesture() {
    if (!card) return;
    let target = index;
    if (didSwipe) {
      if (lastDx < 0) target = index + 1;
      else if (lastDx > 0) target = index - 1;
    }
    commit(target); /* always re-enables transition + snaps */
    card = null;
  }

  document.addEventListener('touchend', endGesture, { passive: true });
  document.addEventListener('touchcancel', endGesture, { passive: true });

  /* A swipe that ends on the anchor must not trigger navigation */
  document.addEventListener('click', (e) => {
    if (!didSwipe) return;
    const swipedCard = e.target.closest('.product-card--swipeable');
    if (swipedCard) e.preventDefault();
    didSwipe = false;
  }, true);
};

/* --- Init on DOM ready ---
   Quick-add ("Elegir Talla") now opens the shared bottom sheet —
   see assets/quick-add-sheet.js, initialized independently since it's
   loaded from snippets/quick-add-sheet.liquid, not this file. */
document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initCartOverlay();
  initSmoothScroll();
  initSwipeableCards();
});
